// extracted by mini-css-extract-plugin
module.exports = {"container":"_2iXUoQ00Aqx37yarA1zDoH","icon":"_2nRIzNRJaoBbLC9XsM2AxJ"};